import React from 'react';
import Popup from './PopupItem';
import ManageFormApi from '../../../../api/ManageFormApi';

import { DotsIcon } from '../../../../images/icons/WrapSvg';


class Rule extends React.Component {
    state = {
        rule: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        const { rule, selectedField, selectedType, selectedRule } = props;
        if (rule !== state.rule || selectedType !== state.selectedType || selectedField !== state.selectedField || selectedRule !== state.selectedRule) {
            state.rule = rule;
            state.selectedField = selectedField;
            state.selectedType = selectedType;
            state.selectedRule = selectedRule;
            state.enabled = (selectedRule && rule && selectedRule.id === rule.id) ||
                            (rule[selectedType] && rule[selectedType].reduce((r, i) => {r = r || (i.parametros && i.parametros.campo && i.parametros.campo.codigo === selectedField) ; return r}, false));
            return state;
        }
        return null;
    }

    handleOpen = (event) => {
        this.setState({ open: event.currentTarget });
    };

    handlePopup = (task) => (event) => {
        const { rule } = this.state;
        switch (task) {
            case 'delete':
                ManageFormApi.deleteRule(rule)
                    .then((data) =>{
                        console.log(data);
                        this.props.onDeleteRule(data);
                    })
                break;
            case 'duplicity':
                    ManageFormApi.getRule(rule.id).then((data) => {
                        data.id = undefined;
                        data.nombre = '';
                        this.props.onEditRule(data);
                    });
                break;
            case 'edit':
                ManageFormApi.getRule(rule.id).then((data) => {
                    this.props.onEditRule(data)
                });
                break;
            default:
                break;
        }
        this.setState({ open: null });
    };


    render() {
        const { rule, open, selectedField, selectedRule, enabled } = this.state;
        return (
            <div className={"flex_auto_row  bg_purple margin_bottom_12 " + ((selectedRule || selectedField) && !enabled ? "disabled" : "") }>
                <div className="flex_full_row bg_light_purple_40 margin_left_6 padding_borders_flat align_center" >
                    <div className="flex_full_row barlow_semibold_button c_dark_grey_blue padding_top_12 padding_bottom_12 hand" onClick={(event) => this.props.onSelectedRule(rule)}>
                        {rule.nombre}
                    </div>
                    <DotsIcon color="primary" className="margin_right_6 hand" onClick={this.handleOpen} />
                </div>
                {open && <Popup open={open} onClick={this.handlePopup} />}
            </div>
        );
    }
}

export default Rule;



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/Rule.js